import AdvertisingRepository from './AdvertisingRepository.js'

/**
 * @class
 * @implements AdvertisingRepository
 */
export class HTTPSaitamaRepository extends AdvertisingRepository {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Fetcher} deps.fetcher
   * @param {Function} deps.log
   */
  constructor({config, fetcher, log, valueObject}) {
    super()

    this._config = config
    this._fetcher = fetcher
    this._log = log
    this._valueObject = valueObject
    this._defaultBrandDayEnabledResponse = this._config.get('DEFAULT_BRAND_DAY_ENABLED_RESPONSE')
    this._advertisingConfigurationUrl = this._buildUrl()
  }

  /**
   * @return {String}
   */
  _buildUrl() {
    const baseUrl = this._config.get('SAITAMA_CONFIG_URL')
    const {ADVERTISING_SITE: advertisingSiteId} = this._config.get('advertising')
    return `${baseUrl}/features/${advertisingSiteId}`
  }

  async getAdvertisingConfiguration() {
    try {
      const response = await this._fetcher.get(this._advertisingConfigurationUrl, {
        headers: {Accept: 'application/json'}
      })
      const advertisingConfiguration = response?.data
      return this._valueObject({
        brandDayEnabled: advertisingConfiguration?.features?.brandDay?.enabled
      })
    } catch (error) {
      this._log(`Getting advertising saitama configuration has had an error ${error}`)
    }
    return this._valueObject({
      brandDayEnabled: this._defaultBrandDayEnabledResponse
    })
  }
}
